'use client'
import { Controller } from 'react-hook-form'
import ReactSelect from '../form/ReactSelect'

interface Props {
  data: any[]
  className: string
  labelColor?: string
}
interface PropsFields {
  classNameContainer: string
  typeComp: string
  controllerProps: any
  compProps: any
  labelColor?: string
}

const FilterSelectGroup = ({ data, className, labelColor }: Props) => {
  return (
    <div className={className}>
      {data.map(
        ({
          typeComp,
          classNameContainer,
          controllerProps,
          compProps,
        }: PropsFields) => {
          return (
            <div className={classNameContainer} key={controllerProps.name}>
              <Controller
                {...controllerProps}
                render={({ field, fieldState }) => (
                  <>
                    {typeComp === 'react-select' && (
                      <ReactSelect
                        {...compProps({ field, fieldState, labelColor })}
                      />
                    )}
                  </>
                )}
              />
            </div>
          )
        },
      )}
    </div>
  )
}

export default FilterSelectGroup
